import React, { useEffect, useState } from "react";
import { AiOutlineArrowLeft } from "react-icons/ai";
import { ChannelCard } from "./shared/ChannelCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import LiveTVService from "services/liveTv/LiveTVService";
import TvChannelSkeleton from "components/skeleton/TvChannelSkeleton";
import TvChannelSeeAllSkeleton from "components/skeleton/TvChannelSeeAllSkeleton";
import LiveTVGenreSelector from "./shared/LiveTVGenreSelector";
import NoSearch from "pages/searchPage/shared/NoSearch";
import { Adsense } from "@ctrl/react-adsense";
import GeneralServices from "services/General/GeneralServices";

function SeeAllChannels() {
  const { slug } = useParams();
  const [channels, setChannels] = useState<any>(null);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [category, setCategory] = useState<any>(slug);
  const [gAdSlot, setgAdSlot] = useState<any>();

  useEffect(() => {
    GeneralServices.getAllConfigData()
      .then((res) => {
        const PageStatus = res?.data?.filter(
          (item: any) => item?.title === "is_livetv_gAd" && item?.value !== null
        );
        if (PageStatus[0]?.value === "1") {
          const filteredData = res?.data?.filter(
            (item: any) => item?.title === "gAdSlot" && item?.value !== null
          );
          setgAdSlot(filteredData[0]?.value);
          console.log("setgAdStatus", filteredData[0]?.value);
        }
      })
      .catch((e) => {});
  }, []);

  useEffect(() => {
    setCategory(slug);
  }, [slug]);

  const navigate = useNavigate();
  const location = useLocation();

  // Go back if there's history, otherwise fall back to a safe route
  const handleBack = () => {
    if (location.key && location.key !== "default") {
      navigate(-1);
    } else {
      navigate("/"); // fallback when opened directly / no history
    }
  };

  useEffect(() => {
    setIsLoading(true);
    LiveTVService.getAllChannels().then((res) => {
      setIsLoading(false);
      setChannels(res.data);
    });
  }, []);

  useEffect(() => {
    setIsLoading(true);
    if (category === "all") {
      LiveTVService.getAllChannels().then((res) => {
        setIsLoading(false);
        setChannels(res.data);
      });
    } else {
      LiveTVService.getLiveTvByCategory(category).then((res) => {
        setIsLoading(false);
        setChannels(res.data);
      });
    }
  }, [category]);

  // category
  useEffect(() => {
    setCategory("all");
  }, []);

  return (
    <>
      {!isLoading && (
        <div>
          {/* main topic section */}
          <div>
            <button
              type="button"
              className="mb-5 flex h-10 w-10 items-center justify-center rounded-full bg-white text-black transition-colors hover:bg-white/90 max-sm:ml-[16px]"
              onClick={handleBack}
              aria-label="Go back"
            >
              <AiOutlineArrowLeft />
            </button>
          </div>
          <div className="mb-8 flex w-[98%] items-center justify-between gap-4 border-b border-white/10 pb-5 max-sm:flex-col max-sm:items-start max-sm:gap-3">
            <h1 className="text-xl font-semibold tracking-tight text-white md:text-3xl lg:text-2xl max-sm:ml-2">
              All Channels
            </h1>
            <LiveTVGenreSelector
              category={category}
              setCategory={setCategory}
              page={true}
            />
          </div>
          {gAdSlot && (
            <Adsense
              client="ca-pub-5773929890067376"
              slot={gAdSlot}
              style={{
                display: "flex",
                marginBottom: "20px",
                marginTop: "20px",
                height: "90px",
                justifyContent: "center",
              }}
              format="horizontal"
              data-full-width-responsive="true"
            />
          )}

          {channels && (
            <div className="">
              {channels && (
                <>
                  {channels?.length > 0 ? (
                    <div className="mb-28 mt-4 grid w-full grid-cols-2 gap-x-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 max-sm:w-full">
                      {channels.map((channel: any, index: number) => (
                        <div key={index} className="mb-10">
                          <ChannelCard data={channel} img={channel.thumbnail} />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="flex w-full items-center justify-center">
                      <NoSearch text={category.replace("-", " ")} />
                    </div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      )}
      {isLoading && <TvChannelSeeAllSkeleton />}
    </>
  );
}

export default SeeAllChannels;